// extracted by mini-css-extract-plugin
export default {"wrapper":"MarkingSymbols-module__wrapper","shapes":"MarkingSymbols-module__shapes","active":"MarkingSymbols-module__active"};